import React from "react";

const PersonalProfile = () => {
  return <div>PersonalProfile</div>;
};

export default PersonalProfile;
